<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">
                <ng-container *ngIf="data?.boat; else noBoat">
                    {{ 'boats.ownerBoatDialog.editTitle' | translate : { boatName: data.boat.name } }}
                </ng-container>
                <ng-template #noBoat>
                    {{ 'boats.dialogs.selectBoat' | translate }}
                </ng-template>
            </h2>
            <button data-test="B-Close-dialog" mat-icon-button (click)="dialogRef.close(false)"
                    [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 p-sm-24 m-0" fusePerfectScrollbar>

        <form [formGroup]="boatForm">

            <ng-container *ngIf="loadingBoats; else formContent">
                <div style="display: flex; justify-content: center; align-items: center;">
                    <mat-spinner [diameter]="40"></mat-spinner>
                </div>
            </ng-container>

            <ng-template #formContent>

                <ng-container *ngIf="showCheckbox">
                    <div class="pb-16">
                        <mat-checkbox data-test="FCB-Liegeplatz gebühr hinzufügen"
                                      [(ngModel)]="onlyBoatsWithoutOwner"
                                      [ngModelOptions]="{standalone: true}">
                            {{ 'boats.ownerBoatDialog.onlyBoatsWithoutOwner' | translate : { boats: ('boats.plural' | translate) } }}
                        </mat-checkbox>
                    </div>
                </ng-container>

                <ng-container *ngIf="!boats?.length && onlyBoatsWithoutOwner">
                    <u2b-message>
                        <header>{{ 'boats.ownerBoatDialog.noAssignmentHeader' | translate }}</header>
                        <p>{{ 'boats.ownerBoatDialog.allBoatsHaveOwner' | translate : { boats: ('boats.plural' | translate) } }}</p>
                        <p>
                            <strong>{{ 'boats.ownerBoatDialog.tipLabel' | translate }}</strong><br>
                            <span [innerHTML]="'boats.dialogs.ifBoatHasMultipleOwners' | translate"></span>
                        </p>
                    </u2b-message>
                </ng-container>

                <div class="mb-24" fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field fxFlex appearance="outline" floatLabel="always">
                        <input type="text" matInput data-test="FI-Boote durchsuchen..."
                               formControlName="boat"
                               [placeholder]="'boats.dialogs.filterBoats' | translate"
                               [matAutocomplete]="boatSelector">
                        <mat-error>{{boatForm.get('boat').errors | firstErrorMessage}}</mat-error>
                    </mat-form-field>

                    <mat-autocomplete #boatSelector="matAutocomplete" [displayWith]="displayBoatWith">
                        <ng-container *ngIf="isSearching">
                            <mat-option disabled>
                                <mat-spinner diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
                                {{ 'boats.dialogs.searchingBoats' | translate }}
                            </mat-option>
                        </ng-container>

                        <ng-container *ngIf="!isSearching">
                            <ng-container *ngFor="let boat of filteredBoats$ | async">
                                <ng-container
                                        *ngIf="!onlyBoatsWithoutOwner || (!boat.owner && !boat.ownerCompany)">
                                    <mat-option [value]="boat">
                                        <bcm-boat-link [disableLink]="true" [boat]="boat"></bcm-boat-link>
                                    </mat-option>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="!boats?.length">
                                <mat-option disabled>
                                    {{ 'boats.dialogs.noBoatsFound' | translate }}
                                </mat-option>
                            </ng-container>
                        </ng-container>
                    </mat-autocomplete>
                </div>
            </ng-template>

            <ng-container *ngIf="showBoatOwnerInfo">
                <u2b-message type="warning">
                    <header>{{ 'boats.dialogs.hasOwnerHeader' | translate }}</header>
                    <p [innerHTML]="'boats.dialogs.ownerChangeInfo' | translate : {
                        currentOwnerName: currentOwnerName,
                        newOwnerName: data?.ownerName
                    }"></p>
                </u2b-message>
            </ng-container>

            <app-input-date formControlName="isOwnerUntil">
                <label>{{ showBoatOwnerInfo ? ('boats.ownerBoatDialog.ownerChangeAtLabel' | translate) : ('boats.ownerBoatDialog.ownerSinceLabel' | translate) }}</label>
            </app-input-date>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="flex-end center">

        <ng-container *ngIf="!loadingBoats">
            <ng-container *ngIf="!boats?.length">
                <button data-test="B-Speichern" mat-flat-button
                        (click)="dialogRef.close(false)"
                        class="save-button mat-accent"
                        [attr.aria-label]="'common.save' | translate">
                    {{ 'common.ok' | translate }}
                </button>
            </ng-container>

            <ng-container *ngIf="boats?.length">
                <button data-test="B-Speichern" mat-flat-button
                        (click)="save()"
                        class="save-button mat-accent"
                        [disabled]="isSaving || !boatForm.dirty"
                        [attr.aria-label]="'common.save' | translate">
                    {{ showBoatOwnerInfo ? ('boats.ownerBoatDialog.performOwnerChange' | translate) : ('boats.ownerBoatDialog.assignPlural' | translate : { boats: ('boats.plural' | translate) }) }}
                </button>
            </ng-container>
        </ng-container>

    </div>
</div>
